<template>
  <div class="">
    <b-button v-b-toggle.treasuriesTransactions class="btn btn-lg btn-collapse">
      {{ $t("treasuriesTransactions") }}
      <i class="fa fa-angle-down" aria-hidden="true"></i>
    </b-button>
    <b-collapse id="treasuriesTransactions">
      <div class="my-card">
        <div class="row">
          <div class="form-label-group col-md-6 col-lg-6">
            <input
              type="checkbox"
              id="establishmentTreasuryTransactionsView"
              v-model="
                usersPrivilegeTreasuriesTransaction.establishmentTreasuryTransactionsView
              "
              class="checkbox"
            />
            <label
              class="mt-1 ml-2"
              for="establishmentTreasuryTransactionsView"
              >{{ $t("view") }}</label
            >
          </div>
          <div class="form-label-group col-md-6 col-lg-6">
            <input
              type="checkbox"
              id="establishmentTreasuryTransactionsAdd"
              v-model="
                usersPrivilegeTreasuriesTransaction.establishmentTreasuryTransactionsAdd
              "
              class="checkbox"
            />
            <label
              class="mt-1 ml-2"
              for="establishmentTreasuryTransactionsAdd"
              >{{ $t("add") }}</label
            >
          </div>
        </div>
      </div>
    </b-collapse>
  </div>
</template>

<script>
export default {
  name: "UsersPrivilegeTreasuriesTransaction",
  data() {
    return {
      language: localStorage.getItem("userLanguage") || "ar",
    };
  },
  props: ["usersPrivilegeTreasuriesTransaction"],
  methods: {},
};
</script>

<style scoped lang="scss"></style>
